import { type FC } from "react";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { truncateText } from "@root/shared/utils/truncateText";
import { type ClientImage } from "@clientFrontend/features/publication/components/ClientImageLibraryModal/type";
import * as styles from "./styles.css";

type SelectedClientImage = ClientImage & {
  isSelected: boolean;
};

type Props = {
  clientImage: SelectedClientImage;
  handleClickClientImageCassette: (clientImage: ClientImage) => void;
};

export const ClientImageCassette: FC<Props> = ({ clientImage, handleClickClientImageCassette }) => {
  return (
    <div
      key={clientImage.id}
      className={styles.container}
      onClick={() => handleClickClientImageCassette(clientImage)}
      onKeyDown={() => handleClickClientImageCassette(clientImage)}
      role="button"
      tabIndex={0}
    >
      <div className={clientImage.isSelected ? styles.rectangle : ""}>
        {clientImage.isSelected && <div className={styles.selectedLabel}>選択中</div>}
        <LazyLoadImage
          src={clientImage.imageUrl}
          alt={`${clientImage.imageUrl}の企業画像`}
          dummyImgPath={clientImage.imageUrl}
          width={144}
          height={81}
        />
        <div className={styles.filename}>{truncateText(clientImage.filename, 10)}</div>
      </div>
    </div>
  );
};
